/*
 * @Author: your name
 * @Date: 2022-01-07 15:30:27
 * @LastEditTime: 2022-10-24 15:32:03
 * @LastEditors: zhujuan
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /nqc-pc-ui/src/common/utils/routerComponentWrapper.js
 */
import store from '@/frameworks/store'

const modelNotExisted = (model) =>
  // eslint-disable-next-line
  !(model in store._modules.root._children);

// wrapper of dynamic
export const dynamicWrapper = (models, component) => {
  // () => require('module')
  // transformed by babel-plugin-dynamic-import-node-sync
  models.forEach((model) => {
    const modelName = model.substring(model.lastIndexOf('/') + 1)
    if (modelNotExisted(modelName)) {
      //刷新时，新注册模块时 vuex有createPersistedState缓存，所以需要先移除state对象 否则报warn
      if (store.state[modelName]) {
        delete store.state[modelName]
      }
      //  console.log('easyMoney模块已存在,无法动态', store.hasModule(modelName))
      // eslint-disable-next-line

      store.registerModule(
        modelName,
        require(`../../apps/modules/${model}/_store/`).default
      )
      // console.log('&&&&&&&&&&&&_store.registerModule(model,require');
      // app.model(require(`../models/${model}`).default);
    }
  })
  return component
  // return props => {
  //   console.log('&&&&&&&&&&&&_props => {');
  //   var ComponentClass = Vue.extend(component().default);
  //   console.log('&&&&&&&&&&&&_ComponentClass');
  //   let  aa = new ComponentClass({
  //     ...props
  //   });
  //   console.log(aa);
  //   // return CreateElement(component().default, {
  //   //   ...props
  //   // });
  // };
}
